<template>
  <b-modal id="update-name-modal"
           title="Update Name"
           ref="updateNameModal"
           size="md"
           button-size="sm"
           hide-header-close
           no-close-on-backdrop
           no-close-on-esc
           no-stacking
           centered
           @cancel="resetModal">

    <div class="container mb-2 p-0">
      <b-form-group
        id="first-name"
        label-cols-lg="3"
        content-cols-lg="9"
        label="First Name:"
        label-class="font-weight-bold pt-0"
        label-for="first-name"
        description="Your First Name or Given Name">
        <b-form-input id="first-name"
                      name="firstName"
                      v-model.trim="editedFirstName"
                      placeholder="First name (at least 1 character)"
                      v-validate="'required|min:1|max:50'"
                      data-vv-as="First Name"
                      data-vv-delay="500"
                      :class="{ 'is-invalid': errors.has('firstName') }"
                      aria-describedby="first-name-input-live-feedback"
        ></b-form-input>
        <b-form-invalid-feedback id="first-name-input-live-feedback">
          {{ errors.first("firstName") }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        id="last-name"
        label-cols-lg="3"
        content-cols-lg="9"
        label="Last Name:"
        label-class="font-weight-bold pt-0"
        label-for="last-name"
        description="Your Last Name or Surname">
        <b-form-input id="last-name"
                      name="lastName"
                      v-model.trim="editedLastName"
                      placeholder="Last name (at least 2 characters)"
                      v-validate="'required|min:2|max:50'"
                      data-vv-as="Last Name"
                      data-vv-delay="500"
                      :class="{ 'is-invalid': errors.has('lastName') }"
                      aria-describedby="last-name-input-live-feedback"
        ></b-form-input>
        <b-form-invalid-feedback id="last-name-input-live-feedback">
          {{ errors.first("lastName") }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        id="user-name"
        label-cols-lg="3"
        content-cols-lg="9"
        label="Username:"
        label-class="font-weight-bold pt-0"
        label-for="user-name"
        description="Your Username">
        <b-form-input id="user-name"
                      name="userName"
                      v-model.trim="editedUserName"
                      placeholder="Username (at least 2 characters)"
                      v-validate="'required|min:2|max:55'"
                      data-vv-as="Username"
                      :class="{ 'is-invalid': errors.has('userName') }"
                      aria-describedby="user-name-input-live-feedback"
        ></b-form-input>
        <b-form-invalid-feedback id="user-name-input-live-feedback">
          {{ errors.first("userName") }}
        </b-form-invalid-feedback>
      </b-form-group>
    </div>

    <template slot="modal-footer">
      <b-btn variant="secondary" @click="() => { this.resetModal(); this.$refs.updateNameModal.hide() }">Cancel
      </b-btn>
      <b-btn variant="primary" @click="save()" :disabled="isLoadingUpdate">
        <b-spinner v-if="isLoadingUpdate" small></b-spinner>
        Save
      </b-btn>
    </template>
  </b-modal>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

export default {
  name: "UpdateNameModal",
  data() {
    return {
      editedFirstName: null,
      editedLastName: null,
      editedUserName: null,
    }
  },
  created() {
    this.editedFirstName = this.firstName
    this.editedLastName = this.lastName
    this.editedUserName = this.userName
  },
  watch: {},
  computed: {
    ...mapGetters({
      isLoadingUpdate: "user/profile/isLoadingUpdate",
      error: "user/profile/error",
      firstName: "user/profile/firstName",
      lastName: "user/profile/lastName",
      userName: "user/profile/userName",
    }),
  },
  methods: {
    ...mapActions({
      updateUserProfile: 'user/profile/updateUserProfile',
    }),
    resetModal() {
      this.editedFirstName = this.firstName
      this.editedLastName = this.lastName
      this.editedUserName = this.userName
    },
    save() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.updateUserProfile({
            firstName: this.editedFirstName,
            lastName: this.editedLastName,
            username: this.editedUserName,
          }).then(update => {
            if (update) {
              this.$refs.updateNameModal.hide()
            }
          })
        }
      })
    }
  }
}
</script>


<style class="scss" scoped>
</style>
